var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 routedetails",
    class: {
      row: true,
      tableFixHead1: true
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.Shipmentloader
    },
    on: {
      "update:active": function($event) {
        _vm.Shipmentloader = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [(_vm.IsCheckbox) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [(!_vm.checkboxDisabled) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectAllCheckbox),
      expression: "selectAllCheckbox"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.selectAllCheckbox) ? _vm._i(_vm.selectAllCheckbox, null) > -1 : (_vm.selectAllCheckbox)
    },
    on: {
      "click": function($event) {
        return _vm.selectAllItems($event)
      },
      "change": function($event) {
        var $$a = _vm.selectAllCheckbox,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectAllCheckbox = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.selectAllCheckbox = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectAllCheckbox = $$c
        }
      }
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("AWB/ShippingID")]), _vm._v(" "), _vm._l((_vm.columns), function(cols, index) {
    return _c('th', {
      key: index,
      staticClass: "text-center tableheader"
    }, [_vm._v(" " + _vm._s(cols.label))])
  }), _vm._v(" "), (_vm.IsEditSequenceNo) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Edit SequenceNo")]) : _vm._e(), _vm._v(" "), (_vm.IsRemoveShipment) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Remove")]) : _vm._e(), _vm._v(" "), (_vm.IsWithDraw) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Withdraw Request")]) : _vm._e(), _vm._v(" "), (_vm.IsDropDown) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Select User's")]) : _vm._e(), _vm._v(" "), (_vm.IsTakeAction) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")]) : _vm._e(), _vm._v(" "), (_vm.IsRaiseBtnAction) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")]) : _vm._e(), _vm._v(" "), (_vm.BatchID) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Batch ID")]) : _vm._e(), _vm._v(" "), (_vm.ShipmentsNum) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("No of Shipments")]) : _vm._e(), _vm._v(" "), (_vm.ExchangeType) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Exchange Type")]) : _vm._e(), _vm._v(" "), (_vm.RemoveAllocatedShipment) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Remove")]) : _vm._e()], 2)]), _vm._v(" "), _c('tbody', [(_vm.showShipmentsList.length > 0) ? _vm._l((_vm.showShipmentsList), function(row, index) {
    return _c('tr', {
      key: index
    }, [(_vm.IsCheckbox) ? _c('td', {
      staticClass: "text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedItemsOnChild),
        expression: "selectedItemsOnChild"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": row,
        "checked": Array.isArray(_vm.selectedItemsOnChild) ? _vm._i(_vm.selectedItemsOnChild, row) > -1 : (_vm.selectedItemsOnChild)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.selectedItemsOnChild,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = row,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedItemsOnChild = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedItemsOnChild = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedItemsOnChild = $$c
          }
        }, function($event) {
          return _vm.selectedItemdata($event, row)
        }]
      }
    })]) : _vm._e(), _vm._v(" "), (row.requestid && row.shipmentcount && row.shipmentcount > 0) ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.requestid)), _c('br'), _vm._v(" and "), _c('a', {
      staticClass: "clickable",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.showMultiShipPopup(row.requestid)
        }
      }
    }, [_c('u', [_c('font', {
      staticStyle: {
        "text-decoration": "underline"
      },
      attrs: {
        "color": "blue"
      }
    }, [_vm._v(" " + _vm._s(row.shipmentcount) + " AWBs")])], 1)])]) : _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row[Object.keys(row).find(function (key) { return key.toLowerCase() === 'shippingid'; })]))]), _vm._v(" "), _vm._l((_vm.columns), function(colsData, index) {
      return _c('td', {
        key: index,
        staticClass: "text-center"
      }, [_vm._v(" " + _vm._s(row[colsData.key]))])
    }), _vm._v(" "), (_vm.IsEditSequenceNo) ? _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-edit",
      staticStyle: {
        "cursor": "pointer",
        "font-size": "14px"
      },
      attrs: {
        "title": "Edit OrderNo"
      },
      on: {
        "click": function($event) {
          return _vm.editSequenceNo(row.ShippingID)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.IsRemoveShipment) ? _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-times-circle",
      staticStyle: {
        "cursor": "pointer",
        "font-size": "18px"
      },
      attrs: {
        "title": "Remove Shipment"
      },
      on: {
        "click": function($event) {
          return _vm.removeShipmentFromRoute(row.ShippingID, row.RouteId)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.IsWithDraw) ? _c('td', {
      staticClass: "text-center"
    }, [_c('b-button', {
      staticClass: "btn btn-primary",
      staticStyle: {
        "cursor": "pointer",
        "padding": "4px"
      },
      attrs: {
        "title": "Withdraw",
        "disabled": row.status.toLowerCase() != 'unassigned' && row.status.toLowerCase() != 'pending'
      },
      on: {
        "click": function($event) {
          return _vm.withDrawReq(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    }), _vm._v(" Withdraw ")])], 1) : _vm._e(), _vm._v(" "), (_vm.IsDropDown && _vm.userList) ? _c('td', {
      key: index,
      staticClass: "text-center"
    }, [_c('select', {
      staticStyle: {
        "cursor": "pointer",
        "padding": "10px",
        "max-width": "150px",
        "border-style": "none",
        "background-color": "gainsboro"
      },
      attrs: {
        "name": "option"
      },
      on: {
        "change": function($event) {
          return _vm.selectUser($event, row)
        }
      }
    }, _vm._l((_vm.userList), function(item) {
      return _c('option', {
        key: item.value,
        domProps: {
          "value": item.value
        }
      }, [_vm._v(_vm._s(item.text))])
    }), 0)]) : _vm._e(), _vm._v(" "), (_vm.IsTakeAction) ? _c('td', {
      staticClass: "text-center"
    }, [_c('b-button', {
      staticClass: "btn btn-primary",
      staticStyle: {
        "cursor": "pointer",
        "padding": "4px"
      },
      attrs: {
        "disabled": _vm.IsUserSelected,
        "title": "Take Action"
      },
      on: {
        "click": function($event) {
          return _vm.takeAction(row)
        }
      }
    }, [_vm._v(" Take Action ")])], 1) : _vm._e(), _vm._v(" "), (_vm.IsRaiseBtnAction) ? _c('td', {
      staticClass: "text-center"
    }, [_c('b-button', {
      staticClass: "btn btn-primary",
      staticStyle: {
        "cursor": "pointer",
        "padding": "4px"
      },
      attrs: {
        "title": "Raise Request"
      },
      on: {
        "click": function($event) {
          return _vm.RaiseReqAction(row)
        }
      }
    }, [_c('i', {}), _vm._v(" Raise Request")])], 1) : _vm._e(), _vm._v(" "), (_vm.BatchID && _vm.EnableHyperLink == true) ? _c('td', {
      staticClass: "text-center"
    }, [_c('a', {
      staticClass: "clickable",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.printShipment(row.AssignBatchNo)
        }
      }
    }, [_c('u', [_c('font', {
      attrs: {
        "color": "blue"
      }
    }, [_vm._v(_vm._s(row.AssignBatchNo))])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.BatchID && _vm.EnableHyperLink == false) ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.AssignBatchNo))]) : _vm._e(), _vm._v(" "), (_vm.ShipmentsNum) ? _c('td', {
      staticClass: "text-center"
    }, [_c('a', {
      staticClass: "clickable",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.ExportCSV(row.shippingIDArray)
        }
      }
    }, [_c('u', [_c('font', {
      attrs: {
        "color": "blue"
      }
    }, [_vm._v(_vm._s(row.NoOfShipments))])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.ExchangeType) ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.getExchangeType(row.ExchangeType)))]) : _vm._e(), _vm._v(" "), (_vm.RemoveAllocatedShipment) ? _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-times-circle",
      staticStyle: {
        "cursor": "pointer",
        "font-size": "18px"
      },
      attrs: {
        "title": "Remove Shipment"
      },
      on: {
        "click": function($event) {
          return _vm.RemoveShipment(row.ShippingID)
        }
      }
    })]) : _vm._e()], 2)
  }) : [_c('tr', [(_vm.Shipmentloader != true) ? _c('td', {
    attrs: {
      "colspan": "15",
      "align": "center"
    }
  }, [_vm._v("No record found")]) : _vm._e()])]], 2)])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b611e2c","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/common/table-template.vue
// module id = 1211
// module chunks = 1